import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalConstants } from '../Constants/global.constants';

export interface FileUploadResponse {
  url: string;
  fileName: string;
  success: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private apiUrl = `${GlobalConstants.API_URL}`;

  constructor(private http: HttpClient) { }

  uploadToBlob(formData: FormData , containerName: string): Observable<FileUploadResponse> {
    // Don't set Content-Type - let browser set it automatically with boundary
    return this.http.post<FileUploadResponse>(`${this.apiUrl}File/upload?containerName=${containerName}`, formData);
  }

  deleteFromBlob(fileUrl: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete`, {
      params: { fileUrl }
    });
  }


  getBlobSASURL(fileName: string, containerName: string): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/File/GetBlobSasUrl?fileName=${fileName}&containerName=${containerName}`
    );
  }

}